import { render, staticRenderFns } from "./CompanyTabs.vue?vue&type=template&id=7bd7d1fb&scoped=true"
import script from "./CompanyTabs.vue?vue&type=script&lang=ts"
export * from "./CompanyTabs.vue?vue&type=script&lang=ts"
import style0 from "./CompanyTabs.vue?vue&type=style&index=0&id=7bd7d1fb&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd7d1fb",
  null
  
)

export default component.exports